/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../resources/datatypes';
import '../../resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "CreateCatalogImageRequest": {
                        "fields": {
                          "idempotencyKey": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "objectId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "image": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 3,
                            "rule": "optional"
                          },
                          "isPrimary": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional"
                          },
                          "makeImageAvailableForSearch": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        }
                      },
                      "CreateCatalogImageResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "image": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CreateCatalogImageRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CreateCatalogImageResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateCatalogImageRequest @ squareup/connect/v2/catalog/interfaces/create-catalog-image.proto at 19:1
 */
export const CreateCatalogImageRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CreateCatalogImageRequest');
fixType(CreateCatalogImageRequest, {
  idempotencyKey: {
    required: true,
    notEmpty: true
  },
  image: {
    required: true
  }
});
Builder.createAndAttachToType(CreateCatalogImageRequest);
/**
 * SOURCE CreateCatalogImageResponse @ squareup/connect/v2/catalog/interfaces/create-catalog-image.proto at 60:1
 */
export const CreateCatalogImageResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CreateCatalogImageResponse');
fixType(CreateCatalogImageResponse);
Builder.createAndAttachToType(CreateCatalogImageResponse);